import React from 'react';
import {
  Button,
  ButtonGroup,
  ButtonGroupProps,
  ButtonProps,
} from '../../components';
import { cn } from '../../utils';

type ButtonGroupInputValue<T = string> = T;

export interface ButtonGroupInputOption<T = string> {
  value: T;
  text: string;
}

export interface ButtonGroupInputProps<T = string> extends ButtonGroupProps {
  options: ButtonGroupInputOption<T>[];
  value?: T;
  onValueChange?: (value: T) => void;
  buttonProps?: ButtonProps & { activeClassName?: string };
}

export const ButtonGroupInput = <T extends ButtonGroupInputValue>({
  options,
  onValueChange,
  value: selectedValue,
  buttonProps: { activeClassName, ...buttonProps } = {},
  ...props
}: ButtonGroupInputProps<T>) => (
  <ButtonGroup {...props}>
    {options.map(({ value, text }) => (
      <Button
        type="button"
        key={value}
        {...buttonProps}
        onClick={() => onValueChange?.(value)}
        value={value}
        className={cn(
          'border-secondary text-secondary w-full border-[1.5px]',
          buttonProps?.className,
          {
            [activeClassName || 'bg-secondary text-primary-foreground']:
              selectedValue === value,
          }
        )}
      >
        {text}
      </Button>
    ))}
  </ButtonGroup>
);
